import { render, staticRenderFns } from "./queryLogistics.vue?vue&type=template&id=4c1f92af&scoped=true&"
import script from "./queryLogistics.vue?vue&type=script&lang=js&"
export * from "./queryLogistics.vue?vue&type=script&lang=js&"
import style0 from "./queryLogistics.vue?vue&type=style&index=0&id=4c1f92af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f92af",
  null
  
)

export default component.exports